import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenLoader, setTitleLoader } from '../../../../config/redux/actions';
import TypeBehaviorService from '../../../../services/typeBehavior';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BodyBehavior from '../../../components/Definitions/Concepts/Behavior/BodyBehavior'
import CustomInput from '../../../components/General/CustomInput';
import _ from 'lodash';
import CustomSelect from '../../../components/General/CustomSelect';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import { simpleAlerts } from '../../../../utils/alerts';
import { CODES } from '../../../../utils/codesHTTP';
import { validationMessages } from '../../../../message/validations';
import { titlesSpinner } from '../../../../message/titlesSpinner';
import { titlesAlerts } from '../../../../message/titlesAlerts';
import Swal from 'sweetalert2';

const newInfo = {
    desComportamiento: null,
    estado_id: 1,
    edit: 1,
}

const Behavior = (props) => {
    const { states, data, setData, getInfo, dataGrupo, valueGrupo, setValueGrupo, dataCopy, setDataCopy } = props;

    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [dataSelected, setDataSelected] = useState(null);
    const [dataExists, setDataExists] = useState(null);

    const dispatch = useDispatch();
    const handleOpenLoader = (value) => dispatch(setOpenLoader(value));
    const handleTitleLoader = (value) => dispatch(setTitleLoader(value));

    useEffect(() => {
        setDataExists(null)
        if (valueGrupo > 0) {
            getComportamientoGrupo();
        }
    }, [valueGrupo])

    const addComportamiento = () => {
        let updData = _.cloneDeep(data);
        updData?.push(newInfo);
        return setData(updData);
    }

    const handleSearch = (search) => {
        setSearch(search);
        const filtered = data.filter(item =>
            item.desComportamiento.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredData(filtered);
    };

     const saveGrupoComportamiento = async (id_estado) => {
         if (dataSelected?.find(e => +e.estado_id !== 1)) {
             simpleAlerts({ message: validationMessages.assign_behavior_state });
             return;
         }
         if (!id_estado || id_estado === 0) {
             simpleAlerts({ message: validationMessages.estado });
             return;
         }
         if (!valueGrupo || valueGrupo === 0) {
             simpleAlerts({ message: validationMessages.grupo });
             return;
         }
 
         const resultSwal = await Swal.fire({
             title: `${+id_estado === 2 ? titlesAlerts.confirm_behavior_grupo_inactive : titlesAlerts.confirm_behavior_grupo}`,
             icon: "info",
             showCancelButton: true,
             confirmButtonColor: "#229954", // "#3085d6",
             confirmButtonText: "Si!",
             cancelButtonColor: "#d33",
             reverseButtons: true,
         });
 
         if (resultSwal.isConfirmed) {
             try {
                 const body = {
                     id_grupo: valueGrupo,
                     id_estado,
                     comportamientos: dataSelected
                 };
                 handleOpenLoader(true);
                 handleTitleLoader(titlesSpinner.behavior_save);
                 const result = await TypeBehaviorService.saveOrUpdateGrupoBehavior(body);
                 if (result.status === CODES.SUCCESS_200) {
                     getComportamientoGrupo();
                     simpleAlerts({ message: (result?.data?.message || ""), type: "success" })
                 } else {
                     simpleAlerts({ message: (result?.response?.data?.message || ""), type: "error" })
                 }
                 return []
             } catch (error) {
                 console.log(`Error en Comportamiento savePlantaGrupo: ${error}`);
             } finally {
                 handleOpenLoader(false);
                 handleTitleLoader(null);
             }
         }
     }

     const getComportamientoGrupo = async () => {
        try {
            setDataExists(null);
            setDataSelected(null);
            handleOpenLoader(true);
            handleTitleLoader(titlesSpinner.comportamiento_grupo_list);
            const result = await TypeBehaviorService.getComportamientoGrupo(valueGrupo);
            if (result.status === CODES.SUCCESS_200) {
                setDataExists(result.data);
            }
            return []
        } catch (error) {
            console.log(`Error en Plant getComportamientoGrupo: ${error}`);
        } finally {
            handleOpenLoader(false);
            handleTitleLoader(null);
        }
    }
     
    return (
        <div>
            <h1 className='text-center title-page'>Definición de Comportamiento</h1>
            <div className='row justify-content-center'>
                <div className='col-md-2'>
                    <CustomInput
                        title={'Buscar'}
                        placeholder={'Buscar comportamiento'}
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
                <div className='col-md-3'>
                    <CustomSelect
                        title={'Grupo'}
                        placeholder={'Selecionar grupo'}
                        options={dataGrupo}
                        value={valueGrupo || 0}
                        onChange={(value, event) => setValueGrupo(value)}
                    />
                </div>
                <div className='col-md-2 d-flex justify-content-evenly align-items-end'>
                    <button className='btn btn-sm btn-primary' type='button' onClick={addComportamiento}><AddCircleIcon fontSize='small' /> Crear</button>
                    <button className='btn btn-sm btn-success' onClick={() => saveGrupoComportamiento(1)}><AddHomeWorkIcon fontSize='small' /> Agregar</button>
                </div>
            </div>
            <div className='row justify-content-center mt-3'>
                <div className='col-md-7 col-sm-10'>
                    <BodyBehavior
                        states={states}
                        data={filteredData.length > 0 ? filteredData : data}
                        setData={setData}
                        getInfo={getInfo}
                        dataSelected={dataSelected}
                        setDataSelected={setDataSelected}
                        id={"id_tipoComportamiento"}
                        dataExists={dataExists}
                        dataCopy={dataCopy} setDataCopy={setDataCopy}

                    />
                </div>
            </div>
        </div>
    )
}

export default Behavior